"use client";

import { useProgress } from "@/app/_contexts/ProgressProvider";
import { Backdrop, CircularProgress, Typography } from "@mui/material";

export function BackdropLoader() {
  const { backdropVisible, backdropLabel } = useProgress();

  return (
    <Backdrop
      open={backdropVisible}
      sx={{ zIndex: 2000, color: "#fff", flexDirection: "column" }}
    >
      <CircularProgress color="inherit" />
      {backdropLabel && (
        <Typography variant="body2" sx={{ mt: 2 }}>
          {backdropLabel}
        </Typography>
      )}
    </Backdrop>
  );
}
